import { User, UserSubscriptionPlan } from '../models'

export const getUserSubscriptionPlan = (user: User): UserSubscriptionPlan => {
  const userGroups = user.groups
  if (userGroups.includes('api-business-plan')) return 'API_PRO'
  else if (userGroups.includes('api-enterprise-plan')) return 'PREMIUM_PLAN'
  return 'BASIC_PLAN'
}
